/*
 * @author Rica Marie del Rio <marie.delrio@mediacorp.com.sg>
 **/

import UrlUtil from "@/libs/util/UrlUtil";
import AssetPoint from "@/libs/world-cup/AssetPoint";
import { Host, HostResolver } from "@/libs/util/HostUtil";

export default class ImageAssetsUrlUtil implements UrlUtil {
  private host: string;
  private year: number;
  private segment: string;

  constructor(cons: AssetPoint) {
    this.host = cons.host;
    this.year = cons.year;
    this.segment = cons.segment;
  }

  getUrl(data?: any): string {
    const paths: string[] = [];

    const ehost: Host = HostResolver.toHost(this.host);

    if (ehost !== Host.LOCALHOST) {
      paths.push(this.host);
      if (this.segment !== undefined) {
        paths.push(this.segment);
      }

      paths.push("img");
      return paths.join("/") + "/" + data;
    }

    return this.getFromContext(data);
  }

  getFromContext(logo: any) {
    const image = require.context("@/assets/img/", false);
    return image(`./${logo}`);
  }
}
